var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert2 = function SvgAlert2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0056b1bd-820a-455f-ad2f-5bf2a56caf16a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BB0007",
    fillRule: "evenodd",
    d: "M3.312 5.014a6 6 0 0 0 8.433 8.433zm.943-.943 8.433 8.433a6 6 0 0 0-8.433-8.433M.667 8.76a7.333 7.333 0 1 1 14.666 0 7.333 7.333 0 0 1-14.666 0",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0056b1bd-820a-455f-ad2f-5bf2a56caf16a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .76h16v16H0z"
  })))));
};
export default SvgAlert2;